import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import originMattersImage from '../../assets/images/origin-matters.svg';

const OriginMatters = ({ className }) => {
  return (
    <div className={cn('origin-matters', className)}>
      <img src={originMattersImage} alt="" className="origin-matters__image" />
    </div>
  );
};

OriginMatters.viewModelMeta = 'ignore';

OriginMatters.propTypes = {
  className: PropTypes.string,
};

export default OriginMatters;
